"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTableData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MoreHoriz_1 = __importDefault(require("@mui/icons-material/MoreHoriz"));
const Payment_1 = __importDefault(require("@mui/icons-material/Payment"));
const material_1 = require("@mui/material");
const react_use_1 = require("react-use");
const zustandStore_1 = require("../../../../../zustandStore");
const virtualCard_1 = require("../../../request/virtualCard");
const bouncingLoaderComp_1 = __importDefault(require("../../component/bouncingLoaderComp"));
const walletItem_1 = require("../../component/walletItem");
const walletCard_1 = require("../../walletDetails/walletCard");
const useGetTableData = () => {
    const theme = (0, material_1.useTheme)();
    const { wallet, setWalletCardDetailAside, setIsWalletCardDetailAsideOpen } = (0, zustandStore_1.useZustand)(state => ({
        ...state,
    }));
    const { cards } = wallet;
    const [isReady] = (0, react_use_1.useTimeout)(5000);
    if (cards?.length > 0) {
        return cards.map(card => {
            const cardNumber = (0, virtualCard_1.getCardNumber)(card.card);
            const last4Digits = (cardNumber || '****').slice(-4);
            return [
                {
                    id: 'last4Digits',
                    ui() {
                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "column", children: (0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: 'last 4 digits of card', children: (0, jsx_runtime_1.jsxs)(walletItem_1.CardIcon, { "data-testid": "wallet-card-icon", children: [globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP ? ((0, jsx_runtime_1.jsx)(Payment_1.default, { fontSize: "small", color: "inherit", sx: {
                                                position: 'absolute',
                                                top: '5px',
                                                left: '5px',
                                            } })) : null, (0, jsx_runtime_1.jsx)(material_1.Typography, { style: {
                                                ...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                                    ? {
                                                        color: '#fff',
                                                    }
                                                    : {}),
                                            }, component: "span", children: last4Digits })] }) }) }));
                    },
                },
                {
                    id: 'cardName',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: card.context?.request.title || '' });
                    },
                },
                {
                    id: 'expiryDate',
                    ui() {
                        return ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: card.card?.validEndingOn ? (0, virtualCard_1.getCardValidEndingOnDate)(card.card?.validEndingOn) : 'MM/YYYY' }));
                    },
                },
                {
                    id: 'cardUsage',
                    ui() {
                        return (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: (0, walletCard_1.getVirtualCardTypeLabel)({ card: card.card }) });
                    },
                },
                {
                    id: 'availableAmount',
                    ui() {
                        return isReady() || card.remainingCardValue ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", sx: {
                                color: (card.remainingValue ?? 0) <= 0
                                    ? theme.palette.tsGoColor.red
                                    : globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                                        ? theme.palette.hsbcColor.green
                                        : theme.palette.tsGoColor.green,
                            }, children: card.remainingCardValue || '-' })) : ((0, jsx_runtime_1.jsx)(bouncingLoaderComp_1.default, {}));
                    },
                },
                {
                    id: 'spentAmount',
                    ui() {
                        return isReady() || (card.spent ?? 0) >= 0 ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", sx: [
                                (card.spent ?? 0) > 0
                                    ? {
                                        color: theme.palette.tsGoColor.orange,
                                    }
                                    : {
                                        color: 'inherit',
                                    },
                            ], children: card.spentAmount || '-' })) : ((0, jsx_runtime_1.jsx)(bouncingLoaderComp_1.default, {}));
                    },
                },
                {
                    id: 'approvedAmount',
                    ui() {
                        return isReady() || card.cardAmount ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: card.cardAmount || '-' })) : ((0, jsx_runtime_1.jsx)(bouncingLoaderComp_1.default, {}));
                    },
                },
                {
                    id: 'actions',
                    ui() {
                        return ((0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, direction: "row", sx: {
                                justifyContent: 'flex-end',
                                alignItems: 'flex-end',
                            }, children: (0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "row-actions-btn", variant: "text", "ts-variant": "actionButton", sx: { minWidth: 'initial' }, onClick: () => {
                                    setIsWalletCardDetailAsideOpen(true);
                                    setWalletCardDetailAside(card);
                                }, children: (0, jsx_runtime_1.jsx)(MoreHoriz_1.default, {}) }) }));
                    },
                },
            ];
        });
    }
    return [];
};
exports.useGetTableData = useGetTableData;
